module.exports = {
  place: "Объявление о конкурсе",
  commision: "Председатель комиссии",
  organization: "Организации",
  apply: "Участвующие в конкурсе",
  plan: "Образовательная учебная программа",
  staff: "Сотрудники",
  branch: "Филиалы",
  training: "Курсы повышения",
  "months": {
    "january": "Январь",
    "february": "Февраль",
    "march": "Март",
    "april": "Апрель",
    "may": "Май",
    "june": "Июнь",
    "july": "Июль",
    "august": "Август",
    "september": "Сентябрь",
    "october": "Октябрь",
    "november": "Ноябрь",
    "december": "Декабрь"
  },

  "groups": {
    "createGroupButton": "Создать группу",
    "createGroupTitle": "Создание новой группы",
    "groupType": "Тип группы",
    "stateOrder": "Государственный заказ",
    "languageOfStudy": "Язык обучения",
    "teacher": "Преподаватель",
    "clubCategory": "Категория клуба",
    "clubSubcategory": "Подкатегория клуба",
    "approvedQuantity": "Утверждённое количество",
    "freePlaces": "Свободные места",
    "placeType": "Тип места",
    "placesCount": "Количество мест",
    "groupNameRu": "Название группы (на русском)",
    "groupNameKk": "Название группы (на казахском)",
    "cost": "Стоимость",
    "trainingStartDate": "Дата начала обучения",
    "trainingEndDate": "Дата окончания обучения",
    "branch": "Филиал"
  },
  "common": {
    "branch": "Филиал",
    "address": "Адрес",
    "course": "Курс",
    "places": "Места",
    "fullName": "ФИО",
    "position": "Должность",
    "status": "Статус",
    "noData": "Нет данных",
    "cancel": "Отмена",
    "create": "Создать",
    "selectClubCategory": "Выберите категорию группы",
    "selectClubSubcategory": "Выберите подкатегорию группы",
    "search": "Поиск",
    "select": "Выбрать",
    "actions": "Действия"
  },
  "validation": {
    "selectGroupType": "Выберите тип группы",
    "selectStateOrder": "Выберите государственный заказ",
    "selectLanguage": "Выберите язык обучения",
    "selectTeacher": "Выберите преподавателя",
    "enterGroupName": "Введите название группы",
    "selectPlaceType": "Выберите тип места",
    "enterPlacesCount": "Введите количество мест",
    "placesCountPositive": "Количество мест должно быть положительным числом",
    "enterCost": "Введите стоимость",
    "costNonNegative": "Стоимость не должна быть отрицательной",
    "enterStartDate": "Введите дату начала",
    "enterEndDate": "Введите дату окончания",
    "endDateAfterStart": "Дата окончания должна быть позже даты начала",
    "selectClubCategory": "Выберите категорию клуба",
    "selectClubSubcategory": "Выберите подкатегорию клуба",
    "selectBranch": "Выберите филиал",
    "selectTabels": "Выберите табели",
    "selectYear": "Выберите год",
    "selectMonth": "Выберите месяц",
    "invoiceFileRequired": "Загрузите счет-фактуру",
    "invoiceMustBePdf": "Счет-фактура должна быть в формате PDF",
    "invoiceFileTooLarge": "Файл счета-фактуры слишком большой"
  },
  "errors": {
    "loadGroupTypes": "Ошибка при загрузке типов групп",
    "failedLoadGroupTypes": "Не удалось загрузить типы групп",
    "loadStateOrders": "Ошибка при загрузке государственных заказов",
    "failedLoadStateOrders": "Не удалось загрузить государственные заказы",
    "loadLanguages": "Ошибка при загрузке языков",
    "failedLoadLanguages": "Не удалось загрузить языки",
    "loadTeachers": "Ошибка при загрузке преподавателей",
    "failedLoadTeachers": "Не удалось загрузить преподавателей",
    "loadPlaceTypes": "Ошибка при загрузке типов мест",
    "failedLoadPlaceTypes": "Не удалось загрузить типы мест",
    "groupCreateFailed": "Не удалось создать группу",
    "loadCategories": "Ошибка при загрузке категорий",
    "failedLoadCategories": "Не удалось загрузить категории",
    "loadSubCategories": "Ошибка при загрузке подкатегорий",
    "failedLoadSubCategories": "Не удалось загрузить подкатегории",
    "loadBranches": "Ошибка при загрузке филиалов",
    "failedLoadBranches": "Не удалось загрузить филиалы",
    "actCreateFailed": "Не удалось создать акт",
    "invoiceUploadFailed": "Ошибка при загрузке счета-фактуры"
  },
  "messages": {
    "groupCreatedSuccess": "Группа успешно создана",
    "actCreatedSuccess": "Акт успешно создан",
    "invoiceUploadSuccess": "Счет-фактура успешно загружена"
  },
  "act": {
    "tabels": "Табели",
    "year": "Год",
    "month": "Месяц",
    "branch_name": "Филиал",
    "teacher_full_name": "Преподаватель",
    "group_name": "Группа",
    "status_name": "Статус",
    "place_count": "Мест всего",
    "signed_count": "Подписано",
    "last_updated_at": "Последнее обновление",
    "selectedCount": "Выбрано записей: {count}",
    "createActButton": "Создать акт",
    "createActTitle": "Создание акта",
    "branch": "Филиал",
    "tabelsSelected": "табелей выбрано",
    "invoiceFile": "Счет-фактура (PDF)",
    "uploadingInvoice": "Загрузка счета-фактуры...",
    "invoiceUploaded": "Счет-фактура загружена"
  },
};

